import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-router',
  templateUrl: './button-router.component.html',
  styleUrls: ['./button-router.component.scss']
})
export class ButtonRouterComponent implements OnInit {

  @Input() text = '';
  @Input() class = '';
  @Input() icon = '';
  @Input() route = '';
  @Input() modelState: any;

  constructor() { }

  ngOnInit(): void {
  }
}
